var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor appstore-delete-review-response" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.$t("auto.appStoreDeleteReviewResponseChannelId"))
            ),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "App Store Channel ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.channelId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "channelId", $$v)
              },
              expression: "clone.channelId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.appStoreDeleteReviewResponseYanTSilinecekYorumunBulunduUKanalIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("auto.appStoreDeleteReviewResponseReviewId"))),
          ]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "App Store Review ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.reviewId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reviewId", $$v)
              },
              expression: "clone.reviewId",
            },
          }),
          _vm._v(" "),
          _c("small", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.appStoreDeleteReviewResponseYanTSilinecekYorumunIdsi"
                )
              )
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "warning" },
        [
          _c("a-alert", {
            attrs: {
              message: "Dikkat",
              description:
                "Bu işlem yoruma verilen yanıtı kalıcı olarak silecektir.",
              type: "warning",
              "show-icon": "",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }